import { TransformWrapper, TransformComponent } from "react-zoom-pan-pinch";
import ImageWithSpinner from "../ImageWithSpinner";
import { PhotoResponse } from "@/generated-api";

export function ZoomableImage({ image }: { image: PhotoResponse }) {
  return (
    <TransformWrapper
      initialScale={1}
      minScale={1}
      maxScale={3}
      wheel={{ disabled: true }}
      doubleClick={{ disabled: true }}
      panning={{ disabled: true }}
      pinch={{ disabled: false }}
      limitToBounds={true}
      onPinchingStop={(ref) => {
        setTimeout(() => {
          ref.resetTransform();
        }, 100);
      }}
    >
      <TransformComponent
        wrapperStyle={{ width: "100%", height: "100%" }}
        contentStyle={{ width: "100%", height: "100%" }}
      >
        <ImageWithSpinner
          src={image.photo_url}
          photoType={image.photo_type}
          className="w-full md:rounded-lg"
        />
      </TransformComponent>
    </TransformWrapper>
  );
}
